import { url } from "../url";

export const rtmpDestinationUrl = url;
